import Main from './Main';
import './App.css';
import NavBar from './UI/NavBar';
import Cart from './UI/Cart';
import Modal from './UI/Modal';
import { useState } from 'react';
import CartProvider from './store/CartProvider';

 function App() {
  const [disclaimerVisible, setDisclaimerVisible] = useState(true);
  const hideDisclamer= () => {
    setDisclaimerVisible(false);
  }

  const [cartVisible, setCartVisible] = useState(false);
  const toggleCart =()=>{
    setCartVisible(!cartVisible);
  }



  return (
    <div className="App">
      <CartProvider>
      <NavBar onToggleCart={toggleCart}/>
      {disclaimerVisible && <Modal onHideModal={hideDisclamer}>
        <div className='modal'>
        <h2>Disclaimer</h2>
        <br /><br />
        <p>This website is merely a fan recreation of <a href="http://mydrugs.to" target="_blank" rel="noopener noreferrer">MyDrugs.to</a>  (From the Netflix Series) and does not sell nor promote the use of neither legal nor controlled/illegal substances.
        <br /><br />
        It is merely meant to showcase my skills as a Front End developer</p>
        <br /><br /><br />
        <button onClick={hideDisclamer} className="button">I Understand</button>
        </div> 
      </Modal>}
      {cartVisible &&  <Cart onHideModal = {toggleCart}/> }
      
      <Main></Main>
      </CartProvider>
    </div>
  );
} 

export default App;
